import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class ImagesService {

  constructor() { }

  async getLogo(slugCustomer: string){
    const slugImages = API_ENDPOINT.slugImages;
    const slug = slugCustomer.toLowerCase();
    const logo = `${slugImages}/logo_${slug}.png`;

    return logo;
  }

}
